import * as o from "react";
import e from "../lib/IconBase.es.js";
import r from "../defs/Compass.es.js";
const s = o.forwardRef((a, m) => /* @__PURE__ */ o.createElement(e, { ref: m, ...a, weights: r }));
s.displayName = "CompassIcon";
const c = s;
export {
  c as Compass,
  s as CompassIcon
};
